module.exports = __webpack_public_path__ + "static/media/DSC_0253.208425ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0253.jpg
// module id = 654
// module chunks = 0